import { clsx } from 'clsx'
import { ClickAction, useOnClickAction } from 'hook/useOnClickAction'
import { CSSProperties, ReactNode } from 'react'
import { styles } from 'util/style'
import css from './IconButton.module.scss'

export type IconButtonProps = {
  action?: ClickAction | false
  auto?: boolean
  children?: ReactNode
  className?: string
  disabled?: boolean
  gray?: boolean
  large?: boolean
  link?: boolean
  size?: number
  small?: boolean
  style?: CSSProperties
  title?: string
  success?: boolean
  error?: boolean
  primary?: boolean
  secondary?: boolean
  tertiary?: boolean
  invert?: boolean
  panel?: boolean
  outline?: boolean
  notab?: boolean
}

export function IconButton(props: IconButtonProps) {
  const {
    auto, children, disabled, gray, large, link, size, small, title,
    success, error, primary, secondary, tertiary, invert, panel, outline, notab,
  } = props
  const { busy, onClick } = useOnClickAction(props)
  const typeCn = outline ? css.outline : link ? css.link : css.text
  const sz = size != null ? size : large ? 40 : small ? 24 : 32
  const color = error ? css.error : success ? css.success : primary ? css.primary :
    secondary ? css.secondary : tertiary ? css.tertiary : invert ? css.invert : panel ? css.panel : css.default
  const className = clsx(props.className, css.button, typeCn, color, gray && css.gray, busy && 'ant-btn-loading')
  const style = styles({
    width: auto ? 'auto' : sz,
    minWidth: auto ? sz : null,
    height: sz,
    ...props.style,
  })

  return <button className={className} style={style} disabled={disabled || busy}
    title={title} onClick={onClick} tabIndex={notab ? -1 : undefined}>
    {children}
  </button>
}
